import { createContext } from 'react'
import type { AxiosInstance } from 'axios'

export const axiosContext = createContext<AxiosInstance | undefined>(undefined);
